module.exports = __webpack_public_path__ + "static/img/servcie-banner3.73e1f11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/servcie-banner3.jpg
// module id = /BHj
// module chunks = 32